import { CollaboratorEntity } from "@/entities/CollaboratorEntity.js";
import { apiRequest } from "@/services/api/apiClient.js";
import axios from "axios";

const entity = new CollaboratorEntity();
const getRHClient = () => window.API_RH || axios.create({
    baseURL: window.URL_API_BASE_RH || "",
});

export async function getCollaborators({ page = 1, limit = 10, ...filters } = {}) {
    return apiRequest({
        client: getRHClient(),
        method: "get",
        url: entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getCollaboratorById({ id }) {
    return apiRequest({
        client: getRHClient(),
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}

export async function createCollaborator(data) {
    return apiRequest({
        client: getRHClient(),
        method: "post",
        url: entity.endpoints.create,
        body: data,
    });
}

export async function saveCollaborator(data) {
    const isUpdate = !!data.id;
    const url = isUpdate
        ? entity.getUrl(entity.endpoints.get, { id: data.id })
        : entity.endpoints.create;

    return apiRequest({
        client: getRHClient(),
        method: isUpdate ? "put" : "post",
        url,
        body: data,
    });
}

export async function deleteCollaborator({ id }) {
    const url = entity.getUrl(entity.endpoints.delete, { id });

    return apiRequest({
        client: getRHClient(),
        method: "delete",
        url,
    });
}
